function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.6082 16.3939C8.93283 13.7186 8.32875 11.0432 8.19247 9.97136C8.15439 9.67499 8.25638 9.37777 8.46841 9.16722L10.6334 7.00319C10.9519 6.68491 11.0084 6.18889 10.7697 5.80712L7.3226 0.454552C7.0585 0.0318208 6.51624 -0.120747 6.07046 0.102256L0.536613 2.70847C0.176127 2.88597 -0.0359057 3.26898 0.00502352 3.6687C0.294982 6.42328 1.49589 13.1947 8.15043 19.8497C14.805 26.5046 21.5755 27.705 24.3315 27.995C24.7313 28.0359 25.1143 27.8239 25.2918 27.4634L27.898 21.9296C28.1202 21.4848 27.9686 20.944 27.5477 20.6794L22.195 17.2333C21.8135 16.9943 21.3175 17.0504 20.999 17.3686L18.8349 19.5336C18.6243 19.7456 18.3271 19.8476 18.0307 19.8095C16.9589 19.6733 14.2835 19.0692 11.6082 16.3939Z",
  fill: "#09BAD3"
});

var SvgPhoneIc = function SvgPhoneIc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhoneIc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone_ic.60a930bc.svg";
export { ForwardRef as ReactComponent };